import React from 'react';
import { TasksSummary as TasksSummaryType } from './types';

interface TasksSummaryProps {
  summary: TasksSummaryType;
}

const TasksSummary: React.FC<TasksSummaryProps> = ({ summary }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4 mb-8">
      <div className="bg-white rounded-lg p-4 border border-gray-200">
        <div className="text-2xl font-bold text-gray-900">{summary.total}</div>
        <div className="text-sm text-gray-600">Total</div>
      </div>
      <div className="bg-white rounded-lg p-4 border border-gray-200">
        <div className="text-2xl font-bold text-yellow-600">{summary.pending}</div>
        <div className="text-sm text-gray-600">Pending</div>
      </div>
      <div className="bg-white rounded-lg p-4 border border-gray-200">
        <div className="text-2xl font-bold text-blue-600">{summary.in_progress}</div>
        <div className="text-sm text-gray-600">In Progress</div>
      </div>
      <div className="bg-white rounded-lg p-4 border border-gray-200">
        <div className="text-2xl font-bold text-green-600">{summary.completed}</div>
        <div className="text-sm text-gray-600">Completed</div>
      </div>
      <div className="bg-white rounded-lg p-4 border border-gray-200">
        <div className="text-2xl font-bold text-red-600">{summary.high_priority}</div>
        <div className="text-sm text-gray-600">High Priority</div>
      </div>
      <div className="bg-white rounded-lg p-4 border border-gray-200">
        <div className="text-2xl font-bold text-purple-600">{summary.ai_generated}</div>
        <div className="text-sm text-gray-600">AI Generated</div>
      </div>
      <div className="bg-white rounded-lg p-4 border border-gray-200">
        <div className="text-2xl font-bold text-blue-600">{summary.user_created}</div>
        <div className="text-sm text-gray-600">User Created</div>
      </div>
      <div className="bg-white rounded-lg p-4 border border-gray-200">
        <div className="text-2xl font-bold text-gray-600">{summary.cancelled}</div>
        <div className="text-sm text-gray-600">Cancelled</div>
      </div>
    </div>
  );
};

export default TasksSummary; 